
export const noResultsTemplate = (message, classList) => {
    return "" +
        "<div class=\"alert d-flex align-items-center justify-content-center\">\n" +
        "   <i class=\"bi bi-info-circle fs-4hx me-5\"></i>\n" +
        "   <div class=\"d-flex flex-column\">\n" +
        "       <span class=\"fs-6\">" + message + "</span>\n" +
        "   </div>\n" +
        "</div>\n";
}

export class HandlebarsHelpers {
    static init(){
        const dateFormats = {
            short: "DD MMM YY @ HH:mm",
            long: "dddd DD.MM.YYYY HH:mm"
        };

        Handlebars.registerHelper('ifEquals', function (value1, value2, options) {
            if (value1 === value2) {
                return options.fn(this);
            }
            return options.inverse(this);
        });

        Handlebars.registerHelper('ifNotEquals', function (value1, value2, options) {
            if (value1 === value2) {
                return options.inverse(this);
            }
            return options.fn(this);
        });

        Handlebars.registerHelper("formatDate", function (datetime, format) {
            if (moment) {
                format = dateFormats[format] || format;
                return moment(datetime).format(format);
            } else {
                return datetime;
            }
        });

        Handlebars.registerHelper("formatCurrency", function (value) {

            if(!value)
                return;

            if(Number.isNaN(value))
                return value;

            return Number(value).toFixed(2);
        });

        Handlebars.registerHelper("ifGreaterThan", function (value1, value2, options) {
            if (value1 > value2) {
                return options.fn(this);
            }
            return options.inverse(this);
        });

        Handlebars.registerHelper("unlessObjectEmpty", function (obj, options) {

            const the = this;
            let hasValue = false;

            if (!obj)
                return options.inverse(the);

            Object.keys(obj).forEach(function(item) {
                if(obj[item].length > 0) {
                    hasValue = true;
                }
            });

            return hasValue ? options.fn(the) : options.inverse(the);
        });

    };
}
